var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './sportbook-sidemenu.css';
import React, { useEffect, useState } from 'react';
import { sportsbookFilter, sportsbookList, sportsSummerySubject } from "../../store/sportsbook.store";
import { useNavigate } from "react-router-dom";
import { useForceUpdate } from "../../lib/misc.functions";
import { generatePreCompetitionsGroupList, popularCompetitionList, setFilterCompetitions } from "../../services/sportsbook.services";
import _ from "lodash";
import { getFromLanguageFile } from "../../app";
import { useTranslation } from "react-i18next";
export default function SportBookSideMenu(props) {
    var forceUpdate = useForceUpdate();
    var navigate = useNavigate();
    var eventType = props.eventType;
    var sportSlug = props.sportSlug;
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var base = '/' + i18n.resolvedLanguage;
    var _b = useState(""), searchTerm = _b[0], setSearchTerm = _b[1];
    var _c = useState([]), expandedCountries = _c[0], setExpandedCountries = _c[1];
    var selectedCompetitionIds = props.competitionId ? props.competitionId.split(',') : [];
    useEffect(function () {
        var sub = sportsSummerySubject.subscribe(function () { return forceUpdate(); });
        return function () { return sub.unsubscribe(); };
    }, []);
    var originSportsbookList = _.orderBy(sportsbookList, ['eD', 'cGN', 'cN']).filter(function (el) {
        return el.sS === sportSlug && (Number(el.iLE) === 1 || el.marketOutcomeCount > 0);
    });
    var sportsCompetitions = _.sortBy(generatePreCompetitionsGroupList(originSportsbookList, ['countryName'], false, ['coN']), function (c) { return popularCompetitionList.includes(Object.values(c.competitions)[0][0].cId.toString()) ? 0 : 1; });
    var filteredCompetitions = searchTerm.trim().length >= 2
        ? sportsCompetitions.filter(function (c) {
            var countryName = (c.countryName || '').toLowerCase();
            var term = searchTerm.toLowerCase();
            if (countryName.includes(term))
                return true;
            return Object.values(c.competitions).flat().some(function (ev) {
                return (ev.eN || '').toLowerCase().includes(term);
            });
        })
        : sportsCompetitions;
    var filteredCompetitionsEventCount = filteredCompetitions.map(function (c) { return Object.values(c.competitions).flat().length; }).reduce(function (a, b) { return a + b; }, 0);
    var filteredCompetitionsLiveEventCount = filteredCompetitions.map(function (c) { return Object.values(c.competitions).flat().filter(function (ev) { return ev.cur; }).length; }).reduce(function (a, b) { return a + b; }, 0);
    var handleSearch = function (val) {
        setSearchTerm(val);
        sportsbookFilter.filterKeyword = val.trim().length >= 2 ? val.trim() : '';
        if (props.onFilterChange)
            props.onFilterChange();
        forceUpdate();
    };
    useEffect(function () {
        return function () { sportsbookFilter.filterKeyword = ''; };
    }, []);
    var competitionIdsOf = function (events) {
        return Array.from(new Set(events.map(function (ev) { var _a; return (_a = ev.cId) === null || _a === void 0 ? void 0 : _a.toString(); }).filter(Boolean)));
    };
    var applyCompetitionSelection = function (ids) {
        if (ids.length === 0) {
            setFilterCompetitions('clear');
            navigate(base + '/sports/' + sportSlug + '/' + eventType);
        }
        else {
            sportsbookFilter.filterCompetition = [];
            setFilterCompetitions(ids.join(','));
            navigate(base + '/sports/' + sportSlug + '/' + eventType + '/' + ids.join(','));
        }
        forceUpdate();
    };
    var toggleCompetitions = function (ids) {
        var allSelected = ids.every(function (id) { return selectedCompetitionIds.includes(id); });
        applyCompetitionSelection(allSelected
            ? selectedCompetitionIds.filter(function (id) { return !ids.includes(id); })
            : Array.from(new Set(__spreadArray(__spreadArray([], selectedCompetitionIds, true), ids, true))));
    };
    var toggleCountryExpand = function (countryName) {
        setExpandedCountries(function (prev) { return prev.includes(countryName)
            ? prev.filter(function (n) { return n !== countryName; })
            : __spreadArray(__spreadArray([], prev, true), [countryName], false); });
    };
    return (_jsxs("div", __assign({ id: "left-menu-container", className: "ls-sidemenu-wrapper", style: { width: "17rem" } }, { children: [_jsx("div", __assign({ className: "ls-sidemenu-search-area" }, { children: _jsxs("div", __assign({ className: "ls-sidemenu-search-box" }, { children: [_jsx("i", { className: "bc-i-search" }, void 0), _jsx("input", { type: "text", placeholder: t('search'), value: searchTerm, onChange: function (e) { return handleSearch(e.target.value); } }, void 0)] }), void 0) }), void 0), _jsxs("div", __assign({ className: "ls-sidemenu-list-container" }, { children: [_jsxs("div", __assign({ className: "ls-sidemenu-item", onClick: function () {
                            setSearchTerm("");
                            setFilterCompetitions('clear');
                            sportsbookFilter.filterKeyword = '';
                            navigate(base + '/sports/' + sportSlug + '/' + eventType);
                            if (props.onFilterChange)
                                props.onFilterChange();
                        } }, { children: [_jsx("div", __assign({ className: "ls-sidemenu-icon-wrap" }, { children: _jsx("i", { className: "bc-i-all-sports", style: { fontSize: '20px' } }, void 0) }), void 0), _jsxs("div", __assign({ className: "ls-sidemenu-label", style: { fontWeight: '700' } }, { children: ["All (", filteredCompetitionsEventCount, " / ", filteredCompetitionsLiveEventCount, ")"] }), void 0), _jsx("div", __assign({ className: "ls-sidemenu-checkbox-wrap" }, { children: _jsx("input", { type: "checkbox", checked: selectedCompetitionIds.length === 0 && searchTerm === "", readOnly: true }, void 0) }), void 0)] }), void 0), filteredCompetitions.map(function (item) {
                        var countryIds = competitionIdsOf(Object.values(item.competitions).flat());
                        var isSelected = countryIds.length > 0 && countryIds.every(function (id) { return selectedCompetitionIds.includes(id); });
                        var isExpanded = expandedCountries.includes(item.countryName);
                        var flagClass = (item.countryName || "").toLowerCase().replaceAll(' ', '_').replace(/\(|\)/g, '');
                        return (_jsxs(React.Fragment, { children: [_jsxs("div", __assign({ className: "ls-sidemenu-item", onClick: function () { return toggleCountryExpand(item.countryName); } }, { children: [_jsx("div", __assign({ className: "ls-sidemenu-icon-wrap" }, { children: _jsx("i", { className: "flag-bc ".concat(flagClass) }, void 0) }), void 0), _jsxs("div", __assign({ className: "ls-sidemenu-label" }, { children: [item.countryName, " ", _jsxs("span", __assign({ className: "ls-sidemenu-label-count" }, { children: ["(", item.count, ")"] }), void 0)] }), void 0), _jsx("i", { className: "ls-sidemenu-arrow bc-i-small-arrow-down".concat(isExpanded ? ' ls-sidemenu-arrow-open' : '') }, void 0), _jsx("div", __assign({ className: "ls-sidemenu-checkbox-wrap", onClick: function (e) {
                                                e.stopPropagation();
                                                toggleCompetitions(countryIds);
                                            } }, { children: _jsx("input", { type: "checkbox", checked: isSelected, readOnly: true }, void 0) }), void 0)] }), void 0), isExpanded && Object.values(item.competitions).map(function (events) {
                                    var leagueIds = competitionIdsOf(events);
                                    var isLeagueSelected = leagueIds.every(function (id) { return selectedCompetitionIds.includes(id); });
                                    return (_jsxs("div", __assign({ className: "ls-sidemenu-item ls-sidemenu-sub-item", onClick: function () { return toggleCompetitions(leagueIds); } }, { children: [_jsxs("div", __assign({ className: "ls-sidemenu-label" }, { children: [getFromLanguageFile(events[0].cNId) || events[0].cN, " ", _jsxs("span", __assign({ className: "ls-sidemenu-label-count" }, { children: ["(", events.length, ")"] }), void 0)] }), void 0), _jsx("div", __assign({ className: "ls-sidemenu-checkbox-wrap" }, { children: _jsx("input", { type: "checkbox", checked: isLeagueSelected, readOnly: true }, void 0) }), void 0)] }), events[0].cId));
                                })] }, item.sportId + '-' + item.countryName));
                    })] }), void 0)] }), void 0));
}
